import React from "react";
import { getImageUrl } from "../../utils/commonFunctions";
import placeholderImg from "../../assets/images/placeholder-img.png";

export default function CustomImage({ src, alt = "RedChilli", ...props }) {
  return (
    <img
      src={getImageUrl(src)}
      alt={alt}
      {...props}
      onError={(e) => (e.target.src = placeholderImg)}
    />
  );
}
